import { Button, Icon, useForm } from 'modules';
import React from 'react';
import { useGetCompanyAllQuery } from 'services';
import { PopupWraper } from '../../../components/popup';
import { InputFileXlsx } from 'components/input/file/InputFileXlsx';
import * as XLSX from 'xlsx';
import { Loading } from 'components';
import { CellContext, ColumnDef } from '@tanstack/react-table';
import TableListDataEdit from 'components/Table-list-edit-data ';
import { useCreateMultiUserMutation } from 'services/user/mutation/useCreateMultiUserMutation';
import { RoleTypesAll } from 'configs/constants';
import toast from 'react-hot-toast';
import { set } from 'lodash';
import { normalizedPhoneNumber } from 'utils/helpers/helpers';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import { formatColumn, formatRowData } from 'configs/cell_xlsx';
import { exportHeadersCreateMultiUser } from '../list/configs';

interface CreateUserProps {
  onClose: () => void;
  forceUpdateTable: () => void;
}

const CreateMultiUser = ({ onClose, forceUpdateTable }: CreateUserProps) => {
  const [dataImport, setDataImport] = React.useState<any[]>([]);
  const { data: companyInfo } = useGetCompanyAllQuery();

  const { mutateAsync, isLoading } = useCreateMultiUserMutation();

  const { handleSubmit, resetForm } = useForm({
    structure: [],
    onSubmit: async (values) => {
      const normalizedValues: any = dataImport.map((item) => {
        let role = 'Agency';
        if (item['Vai trò']?.trim() === 'Merchant') {
          role = 'OilMc';
        }
        return {
          phoneNumber: item['Tài khoản'],
          fullName: item['Tên tài khoản'],
          email: item['Email'],
          citizenIdentityCardNo: item['CCCD/MST'],
          role: role,
          compId: item['Hợp tác xã'],
          isActive: item['Trạng thái'] === 'Hoạt động' ? true : false,
          accountNumber: item['Tiểu khoản TPBank'],
          bidvVaPayerId: item['Tiểu khoản BIDV'],
          objectType:
            RoleTypesAll[item['Vai trò'] as keyof typeof RoleTypesAll],
        };
      });
      try {
        const res = await mutateAsync({ users: normalizedValues });
        // Show success message
        toast.success('Xử lý thành công. Vui lòng kiểm tra lại thông tin');
        // Reset the form or perform any other actions
        setDataImport((prevData) => {
          const newData = [...prevData];
          newData.forEach((item) => {
            const user = res.data.find(
              (user: any) =>
                user.phoneNumber?.replace('+84', '') ===
                item['Tài khoản']?.replace('+84', '0').slice(1),
            );
            set(item, 'statusUpdate', user?.message);
          });
          return newData;
        });
        // resetForm();
        forceUpdateTable();
        // onClose();
      } catch (error: any) {
        console.log('error', error);
      }
    },
  });

  const checkedDataCompany =
    companyInfo?.map((item) => ({
      label: `${item.compName}`,
      value: item.compId,
    })) || [];

  const handleRemoveRow = (info: CellContext<any, unknown>) => {
    setDataImport((prevData) => {
      const newData = [...prevData];
      newData.splice(info.row.index, 1);
      return newData;
    });
  };

  const handleDownloadTemplate = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Template Người dùng');

    // Định nghĩa headers
    const headerColumn = exportHeadersCreateMultiUser.map((header) => ({
      header: header,
      key: header,
      width: 40,
    }));

    worksheet.columns = headerColumn;
    const firstRow = worksheet.getRow(1);
    firstRow.eachCell((cell) => formatColumn(cell));

    // Thêm dữ liệu mẫu
    const row = worksheet.addRow([
      '1',
      '0987654321',
      'Nguyễn Văn A',
      '123456789',
      'TPBANK_VA',
      'BIDV_VA',
      'demo@gmail.com',
      'Nhân viên',
      '',
      'Hoạt động',
    ]);
    row.eachCell((cell) => formatRowData(cell));

    // Thêm dropdown validation cho các cột
    const roleOptions = Object.keys(RoleTypesAll)
      .map((key) => key as keyof typeof RoleTypesAll)
      .join(',');

    // Dropdown cho vai trò (cột H)
    worksheet.getCell('H2').dataValidation = {
      type: 'list',
      allowBlank: true,
      formulae: [`"${roleOptions}"`],
      showErrorMessage: true,
      errorStyle: 'error',
      errorTitle: 'Sai lựa chọn',
      error: 'Vui lòng chọn một giá trị từ danh sách.',
    };

    // Dropdown cho hợp tác xã (cột I)
    worksheet.getCell('I2').dataValidation = {
      type: 'list',
      allowBlank: true,
      formulae: [`"${checkedDataCompany.map((item) => item.label).join(',')}"`],
      showErrorMessage: true,
      errorStyle: 'error',
      errorTitle: 'Sai lựa chọn',
      error: 'Vui lòng chọn một giá trị từ danh sách.',
    };

    // Dropdown cho trạng thái (cột J)
    worksheet.getCell('J2').dataValidation = {
      type: 'list',
      allowBlank: true,
      formulae: [`"Hoạt động, Không hoạt động"`],
      showErrorMessage: true,
      errorStyle: 'error',
      errorTitle: 'Sai lựa chọn',
      error: 'Vui lòng chọn một giá trị từ danh sách.',
    };

    // Tạo file và download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const now = new Date();
    const fileName = `Template_tao_nguoi_dung_${now
      .toLocaleTimeString('vn-VN', { hour12: false })
      .replace(/:/g, '_')}_${now
      .toLocaleDateString('vi-VN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
      .replace(/\//g, '_')}.xlsx`;

    saveAs(blob, fileName);
  };

  const columnsDefined: ColumnDef<any>[] = [
    {
      accessorKey: 'Tài khoản',
      header: 'Tài khoản',
      cell: (info) => normalizedPhoneNumber(String(info.getValue())),
      meta: {
        editable: true,
      },
    },
    {
      accessorKey: 'Tên tài khoản',
      header: 'Tên tài khoản',
      meta: {
        editable: true,
      },
    },
    {
      accessorKey: 'CCCD/MST',
      header: 'CCCD',
      meta: {
        editable: true,
      },
    },
    {
      accessorKey: 'Tiểu khoản TPBank',
      header: 'Tiểu khoản TPBank',
      meta: {
        editable: true,
      },
    },
    {
      accessorKey: 'Tiểu khoản BIDV',
      header: 'Tiểu khoản BIDV',
      meta: {
        editable: true,
      },
    },
    {
      accessorKey: 'Vai trò',
      header: 'Vai trò',
      cell: (info) => {
        const value = info.getValue();
        const option = [
          { label: 'Nhân viên', value: 'Nhân viên' },
          { label: 'Tài xế', value: 'Tài xế' },
          { label: 'Đối tác', value: 'Đối tác' },
          { label: 'Nhà cung cấp', value: 'Nhà cung cấp' },
          { label: 'Admin', value: 'Admin' },
          // { label: 'Nhân viên đối soát', value: 'Nhân viên đối soát' },
        ].find((opt) => opt.value === value);
        return option ? option.label : value;
      },
      meta: {
        editable: true,
        options: [
          {
            label: 'Nhân viên',
            value: 'Nhân viên',
          },
          {
            label: 'Tài xế',
            value: 'Tài xế',
          },
          {
            label: 'Đối tác',
            value: 'Đối tác',
          },
          {
            label: 'Nhà cung cấp',
            value: 'Nhà cung cấp',
          },
          // {
          //   label: 'Nhân viên đối soát',
          //   value: 'Nhân viên đối soát',
          // },
          {
            label: 'Merchant',
            value: 'Merchant',
          },
          {
            label: 'Admin',
            value: 'Admin',
          },
        ],
      },
    },
    {
      accessorKey: 'Hợp tác xã',
      header: 'Hợp tác xã',
      cell: (info) => {
        const value = info.getValue();
        const option = checkedDataCompany.find((opt) => opt.value === value);
        return (
          <div style={{ width: 150 }}>
            {option ? option.label : String(value)}
          </div>
        );
      },
      meta: {
        editable: true,
        options: checkedDataCompany,
      },
    },
    {
      accessorKey: 'Email',
      header: 'Email',
      meta: {
        editable: true,
      },
    },
    {
      accessorKey: 'Trạng thái',
      header: 'Trạng thái',
      cell: (info) => {
        const value = info.getValue();
        const option = [
          { label: 'Hoạt động', value: 'Hoạt động' },
          { label: 'Không hoạt động', value: 'Không hoạt động' },
        ].find((opt) => opt.value === value);
        return option ? option.label : value;
      },
      meta: {
        editable: true,
        options: [
          {
            label: 'Hoạt động',
            value: 'Hoạt động',
          },
          {
            label: 'Không hoạt động',
            value: 'Không hoạt động',
          },
        ],
      },
    },
    {
      accessorKey: 'Thao tác',
      header: 'Thao tác',
      cell: (info: CellContext<any, unknown>) => {
        return (
          <div
            className='btnRemove'
            style={{
              cursor: 'pointer',
            }}
            onClick={() => handleRemoveRow(info)}
          >
            <Icon.Trash />
          </div>
        );
      },
    },
    {
      accessorKey: 'statusUpdate',
      header: 'Trạng thái cập nhật',
      cell: (info) => {
        const value = info.getValue();
        if (!value) return '';
        if (value == 'Thành Công') {
          return <div style={{ color: 'green' }}>{String(value)}</div>;
        }
        return <div style={{ color: 'red' }}>{String(value)}</div>;
      },
    },
  ];

  const handleUploadFile = (event: any) => {
    try {
      const file = event?.[0];
      if (!(file instanceof Blob)) return; //
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const result = e.target?.result;
          if (!result) return;

          const data = new Uint8Array(result as ArrayBuffer);
          const workbook = XLSX.read(data, { type: 'array' });

          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];

          const jsonData = XLSX.utils.sheet_to_json(sheet);

          const dataHandle: any = jsonData.map((item: any) => {
            const newItem = { ...item };
            if (newItem['Tài khoản']) {
              newItem['Tài khoản'] = normalizedPhoneNumber(
                newItem['Tài khoản'],
              );
            }
            if (newItem['Hợp tác xã']) {
              const compId = checkedDataCompany.find(
                (item) => item.label === newItem['Hợp tác xã'],
              )?.value;
              newItem['Hợp tác xã'] = compId;
            }
            if (newItem['Vai trò']) {
              newItem['Vai trò'] = newItem['Vai trò'].trim();
            }
            if (newItem['Trạng thái']) {
              newItem['Trạng thái'] = newItem['Trạng thái'].trim();
            }
            if (newItem['CCCD/MST']) {
              newItem['CCCD/MST'] = newItem['CCCD/MST'].toString().trim();
            }
            if (newItem['Tiểu khoản TPBank']) {
              newItem['Tiểu khoản TPBank'] = newItem['Tiểu khoản TPBank']
                .toString()
                .trim();
            }
            if (newItem['Tiểu khoản BIDV']) {
              newItem['Tiểu khoản BIDV'] = newItem['Tiểu khoản BIDV']
                .toString()
                .trim();
            }
            if (newItem['Email']) {
              newItem['Email'] = newItem['Email'].toString().trim();
            }
            if (newItem['Tên tài khoản']) {
              newItem['Tên tài khoản'] = newItem['Tên tài khoản']
                .toString()
                .trim();
            }
            return newItem;
          });
          setDataImport(dataHandle);
        } catch (error) {
          console.log('error', error);
          toast.error('Tệp không đúng định dạng. Vui lòng kiểm tra lại');
        }
      };

      reader.readAsArrayBuffer(file);
    } catch (error) {
      console.log('error', error);
      toast.error('Tệp không đúng định dạng. Vui lòng kiểm tra lại');
    }
  };

  return (
    <div className='wrap-pop-up-create-user'>
      <PopupWraper center title='Tạo mới tài khoản' onClose={() => onClose()}>
        <Loading isLoading={isLoading}>
          <div className='container-fluid'>
            <div className='row wrap-form-create-user mb20'>
              <InputFileXlsx
                name='Tải tệp'
                onChange={(event) => {
                  handleUploadFile(event);
                }}
                onTouched={() => {}}
              />
              <div className='col-6 mb16'>
                <Button
                  label='Tải template'
                  buttonType='info'
                  onClick={handleDownloadTemplate}
                />
              </div>
            </div>
          </div>
          <TableListDataEdit<any>
            columns={columnsDefined as ColumnDef<any>[]}
            data={dataImport}
            setData={setDataImport}
            orderColumn
          />

          <div className='wrap-button-create-user'>
            <Button
              label='Tạo mới'
              type='submit'
              onClick={handleSubmit}
              buttonType='success'
              disabled={isLoading}
            />
            <Button
              label='Trở về'
              buttonType='grey'
              onClick={() => onClose()}
            />
          </div>
        </Loading>
      </PopupWraper>
    </div>
  );
};

export default CreateMultiUser;
